import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateFields, validateField } from '../../../../utilities/validation/validator';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const emailIsExist = createAsyncThunk('personalinfo/emailIsExist', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('emailIsExist', [data.eMailAddress]);
    return result;
  } catch (error) {
    return error;
  }
});

const PersonalInfoSlice = createSlice({
  name: 'personalinfo',
  initialState: {
    form: {
      firstName: '',
      lastName: '',
      //id: '',
      email: '',
      valid: '',

      errors: {},
      rules: {
        firstName: {
          required: { value: true, error: 'לא נבחר שם פרטי' },
          pattern: { value: regexPatterns.lettersOnlyRegex, error: 'ערך לא תקין' },
          minLength: { value: 2, error: 'יש להזין לפחות 2 תווים' },
          maxLength: { value: 25, error: 'השם שהוזן ארוך מדי' },
        },
        lastName: {
          required: { value: true, error: 'לא נבחר שם משפחה' },
          pattern: { value: regexPatterns.lettersOnlyRegex, error: 'ערך לא תקין' },
          minLength: { value: 2, error: 'יש להזין לפחות 2 תווים' },
          maxLength: { value: 25, error: 'השם שהוזן ארוך מדי' },
        },
      },
    },
    isReceivingAd: false,
    isReceivingBill: false,
    isEmailFree: '',
  },

  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return { payload: validate };
      },
    },
    clearValid: {
      reducer(state, action) {
        state.form.valid = '';
        state.isEmailFree = '';
      },
    },
    reportAnalytics: (state, action) => { },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return { payload: validate };
      },
    },

    setReceivingAd: {
      reducer(state, action) {
        if (!state.isReceivingAd) {
          state.isReceivingAd = true;
        } else {
          state.isReceivingAd = false;
        }
      },
    },

    setReceivingBill: {
      reducer(state, action) {
        if (!state.isReceivingBill) {
          state.isReceivingBill = true;
        } else {
          state.isReceivingBill = false;
        }
      },
    },
    // setId: {
    //   reducer(state, action) {
    //     if (state.form.id === '') {
    //       state.form.id = action.payload;
    //     }
    //   },
    // },
  },
  extraReducers: {
    [emailIsExist.fulfilled]: (state, action) => {
      state.isEmailFree = action.payload.Body.isSuccess;
    },
  },
});

export const { changeHandler, validateHandler, clearIsValid, setReceivingAd, setReceivingBill, /*setId,*/ clearValid, reportAnalytics } =
  PersonalInfoSlice.actions;

export default PersonalInfoSlice.reducer;
